<template>
  <div id="cardApp" class="app-wrapper">
    <div class="main-wrapper">
      <main class="content-main">
        <img src="@/assets/banner.png" style="width:100%" />
        <img src="@/assets/hktcmbg.png" style="width:100%" />
        <div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
          <h3 style="margin: 0;">Credit Card Application</h3>
        </div>
        <div class="apply-section">
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">Existing Trust Client Application</div>
              <div class="apply-desc">Applicable only to customers who do not need to change their existing mobile phone number, mailing address, nationality, or other information with this bank.</div>
            </div>
            <div class="apply-btn apply-btn-primary" @click="openLoginDialog('existing')">Apply Now</div>
          </div>
          <!-- ✅ 启用查询功能 -->
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">Approval Status</div>
              <div class="apply-desc">Check Credit Card Approval Status</div>
            </div>
            <div class="apply-btn apply-btn-secondary" @click="openQueryDialog">Check Approval Status</div>
          </div>
        </div>
        <div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
          Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
        </div>
      </main>

      <!-- 登录验证弹窗 -->
      <el-dialog :visible.sync="loginVisible" title="Customer Login Verification" width="550px" class="login-dialog" :close-on-click-modal="false">
        <el-form :model="loginForm" label-position="left" label-width="140px">
          <el-form-item label="Client Code:">
            <el-input v-model="loginForm.clientCode" placeholder="Please enter your customer number." class="login-input"></el-input>
          </el-form-item>
          <el-form-item label="Password:">
            <el-input v-model="loginForm.password" type="password" placeholder="Please enter your password." class="login-input"></el-input>
          </el-form-item>
          <el-form-item label="Phone number:">
  <div style="display: flex; gap: 8px;">
    <el-select v-model="loginForm.areaCode" class="area-code-select" style="width: 120px;">
      <el-option label="+86" value="+86" />
      <el-option label="+852" value="+852" />
      <el-option label="+886" value="+886" />
      <el-option label="+60" value="+60" />
      <el-option label="+65" value="+65" />
      <el-option label="+1" value="+1" />
    </el-select>
    <el-input
      v-model="loginForm.phone"
      placeholder="Please enter your mobile phone number."
      class="login-input"
      style="flex: 1;"
    ></el-input>
  </div>
</el-form-item>
          <el-form-item label="Verification code:">
            <div class="verify-row">
              <el-input v-model="loginForm.verificationCode" placeholder="Please enter the verification code." class="verify-input"></el-input>
              <el-button 
              class="verify-btn" 
              @click="sendVerificationCode" 
              :disabled="countdown > 0"
            >
              {{ countdown > 0 ? `${countdown}s Resend later` : 'Request OTP' }}
            </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
          <el-button @click="loginVisible = false">Cancel</el-button>
          <el-button type="primary" @click="handleLogin">Login</el-button>
        </div>
      </el-dialog>

      <!-- 条款及细则弹窗 -->
      <el-dialog :visible.sync="termsVisible" title="Terms and Conditions" width="850px" class="terms-dialog" :before-close="closeTermsDialog">
        <div class="terms-header">HKTCM Global Visa Charge Card Terms and Conditions</div>
<div class="terms-content" ref="termsContentRef" @scroll="handleTermsScroll">
<p><strong>Important Notice! These Terms and Conditions govern your use of the HKTCM Global VISA Charge Card arranged or facilitated by Hong Kong Trust Capital Management Limited (HKTCM) (“the Company,” “we,” or “us”) and its partners. Please read these Terms and Conditions carefully before using the Charge Card. Your use (including activation) of the Card constitutes your acceptance of and agreement to be bound by these Terms and Conditions. Definitions of terms used herein are provided at the end of these Terms and Conditions.</strong></p>
<p><strong>Qualifications and Registration</strong></p>
<p>1.We reserve the right to take the following actions at any time:<br>
a)Modify, update, or alter these terms and conditions; or<br>
b)Charges, fees, or other conditions may apply for the use of this service or any part thereof (subject to reasonable advance notice).<br>
(All of the above shall collectively be referred to as the “Amendments”).</p>
<p>2. We may modify these Terms at any time without notice (except as otherwise provided in paragraph (b) above). Any changes to these Terms may be posted on our website or notified to you via email using the email address provided in your account. Therefore, you should regularly review our website, enable receipt of such push notifications, and ensure the email address and other contact information in your account remain up to date. Your continued use of the Services after such changes take effect constitutes your acceptance of those changes.</p>
<p>3.You must:<br>
a)  Existing trust clients of the Company with account assets meeting the corresponding tier threshold.<br>
b)  Have reached the legal age and possess the capacity to enter into contracts under applicable law.<br>
c)	Reside in a jurisdiction determined by the Company and its partners to be eligible for card issuance.<br>
d)  Comply with all applicable laws, including Anti-Money Laundering (AML) and Know Your Customer (KYC) requirements.<br>
e)  Provide all verification and identity documents as requested by the Company or its partners.
</p>
<p>4.You agree to ensure that your registration information is accurate and updated in a timely manner. Failure to do so may result in the suspension or termination of your service access privileges.</p>
<p>5.The company reserves the right to modify, suspend, or terminate your access to the services at any time and at its sole discretion.</p>
<p><strong>About Debit Cards</strong></p>
<p>6.This card is a prepaid debit card. Your card account is not a checking or savings account and is not linked to any other account you hold, except for cash sub-accounts within trust accounts. This card is not a gift card and cannot be given to others. This card is not a credit card, so you may not have the same rights associated with credit card transactions. Funds in your card account do not earn interest.</p>
<p>7.You may access your account balance through your debit card. You shall be subject from time to time to these Terms and Conditions and other terms governing your account and the applicable payment network or platform. In the event of any inconsistency between these Terms and other terms, these Terms and Conditions shall prevail in relation to your debit card and any services.</p>
<p>8.The ownership of the charge card in your possession belongs to our company. When our company requests its return in accordance with the relevant terms and conditions, you are obligated to return it. </p>
<p>9.The Company may provide, modify, suspend, revoke, or cancel any service, account card, or your use of the account card at any time without prior notice. The Company may also add, modify, restrict, suspend, revoke, or cancel all or any rights, services, facilities, and privileges related to your account card. Upon cancellation of the account card, the full amount of any transaction made using the account card or authentication factor shall be immediately payable. </p>
<p><strong>Your responsibility</strong></p>
<p>10.Even in the following circumstances, you shall remain liable:<br>
i ）You did not sign the sales slip (including where the transaction may be conducted by telephone, mail, electronic means, or direct payment arrangement without requiring a sales slip or your signature); or the signature on the sales slip differs from the signature on your debit card; or <br>
ii ）The transaction was not conducted with your consent.
</p>
<p>11.The account cardholder shall be responsible for the following matters: <br>
i All transactions made using the credit card and authentication factors (including all related fees and charges), including those made with the cardholder's own credit card and authentication factors and those made with the credit card and authentication factors of any supplementary cardholder; and <br>
ii ）The primary cardholder and any supplementary cardholder have failed to comply with these terms and conditions. <br>
a)	The supplementary cardholder shall be responsible for the use of his/her own charge card and authentication factors, but shall not be liable for the use of their charge card or authentication factors by the primary cardholder or any other supplementary cardholder.<br>
b)	Whether or not you are aware of it, you should not use your charge card for any transaction that may violate the laws of any jurisdiction. <br>
c)	Even if your account card has been terminated, you remain responsible for this.
</p>
<p>12. You agree that when the debit card or authentication factor is used to conduct, process, or execute any transaction, it shall be deemed that you have authorized and are aware of such use, regardless of whether you have actually authorized and/or are aware of such use of the debit card or authentication factor. The Company shall debit your account for any amount incurred through transactions or processing using the debit card or authentication factor. The Company's records of all transactions conducted using the debit card or authentication factor shall be deemed accurate and final (except for obvious errors), and you agree to be bound by such records.</p>
<p><strong>Safety and Security Measures </strong></p>
<p>13.You should take appropriate security precautions, including the following:<br>
a)	Sign your account card immediately upon receipt. <br>
b)	Safeguard your debit card and mobile device and keep them in your possession at all times. Treat your debit card with the same care you would cash. <br>
c)	After using the ATM, remember to retrieve your debit card. <br>
d)	Ensure that merchants promptly return the charge card to you after completing the charge card transaction. <br>
e)	Keep your authentication factors and device passwords strictly confidential; <br>
f)	When using authentication factors and device passwords, please ensure that neither the authentication factors nor the device passwords are visible to others. <br>
g)	Regularly change your personal password and device passcode; <br>
h)	If your personal password or device passcode has been or may have been viewed by others, you should change it immediately. <br>
i)	Never write down your authentication factors or device passcode, nor record them on your debit card, store them with your debit card, or handle them in any other way that could allow others to use your debit card, authentication factors, or mobile device. You should obscure any records of your authentication factors or device passcode. <br>
j)	Never use easily guessable numbers as your personal password or device passcode<br> (such as ID numbers, birth dates, phone numbers, or other readily accessible personal information) and use alphanumeric codes where applicable;<br>
k)	Do not use the same private password or device password for other services or purposes, such as connecting to the internet or logging into other websites.<br>
l)	Do not transfer your debit card, authentication factors, device passcode, or mobile device, nor permit any other person to use your debit card, authentication factors, device passcode, or mobile device.<br>
m)	Each time you make a purchase, remember to fill in the total amount on the receipt and include the currency code before the amount. Do not leave any spaces for others to fill in. <br>
n)	Ensure that only one receipt is printed per transaction; <br>
o)	Retain the cardholder stub of each credit card transaction slip and reconcile it with the credit card statement or records; and <br>
p)	Please ensure that the contact information you have registered with our company for receiving important notifications (such as SMS and email notifications for online payments) is up to date so that such notifications can be delivered to you in a timely manner.
</p>
<p><strong>Report immediately if your account card, authentication factor, or mobile device is lost, stolen, or misused.</strong></p>
<p>14.If your debit card, authentication factor, or mobile device is lost, stolen, compromised, or used without authorization, you must promptly report this to us and provide written confirmation as soon as reasonably practicable. You remain liable for all transactions made using your debit card or authentication factor prior to our receipt of your report.</p>
<p>15.	Without limiting or impairing the effect of Section 17(a), if your account statement shows any transaction not authorized by you, you shall promptly notify the Company. You must submit a chargeback request to the Company within 45 days after the transaction. If you fail to notify us within this 45-day period, the transaction shall be deemed correct, final, and binding upon you, and you shall be deemed to have waived any right to raise objections or seek remedies against us in relation to such transaction. </p>
<p><strong>Your Liability for Unauthorized Transactions </strong></p>
<p>16.	If you report the loss, theft, compromise, or unauthorized use of your debit card, authentication factor, or mobile device under Section 14(b), your liability for unauthorized transactions will be determined on a case-by-case basis.</p>
<p>17.	If you knowingly (whether voluntarily or not) permit any other person to use your debit card, authentication factor, or mobile device; or if you commit fraud or act with gross negligence in the use or custody of your debit card, authentication factor, or mobile device. Failure to implement any security measures recommended by us from time to time regarding the use or custody of your debit card, authentication factor, or mobile device may be deemed gross negligence on your part, and you may be held liable for the transaction amount.</p>
<p><strong>Compensation</strong></p>
<p>18.	To the fullest extent permitted by law, you agree to indemnify and hold harmless the Company (and all its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the “Indemnified Parties”) from and against any and all claims, demands, actions, proceedings, liabilities, losses, damages, penalties, penalties, fines, expenses, and costs (including reasonable legal fees as determined by a court of competent jurisdiction) incurred by the Company (and all of its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the “Indemnified Parties”) in connection with:<br>
a)	Your conduct and your use of our services;<br>
b)	You violate these Terms or our Anti-Money Laundering (“AML”) policy;<br>
c)	You violate any law, regulation, or rule;<br>
d)	You violate or infringe upon the Company's copyrights, intellectual property rights, trade secrets, patents, trademarks, service marks, or any other legally protected proprietary rights;<br>
e)	You have failed to properly safeguard or maintain the confidentiality of your account card credentials or any other identity verification data as required under Article 16;<br>
f)	Any damages caused by you to our services, any user, or any other individual or entity; or<br>
g)	Any rights exercised by the Company pursuant to these terms.
</p>
<p>19.	This indemnification includes, but is not limited to, liabilities related to intellectual property, defamation, and invasion of privacy.</p>
<p><strong>Disclaimer and Exceptions </strong></p>
<p>20.	The Company shall not be liable to you or any other person for any of the following (or any one thereof): <br>
a)	Any failure or delay by the Company in providing any services, equipment, or other facilities to you that may be attributable to circumstances beyond the Company's reasonable control;<br>
b)	The availability or performance of any point-of-sale terminal or other device provided or operated by a merchant or any other person for the use of a charge card or any of its features (including contactless payment functionality); and <br>
c)	Consequential or indirect losses arising from or in connection with the use of your debit card or authentication factor.<br>
</p>
<p>21The Company shall not be liable for any merchant's refusal to accept your charge card or authentication factor. The Company shall also not be liable for any goods or services provided to you by any merchant. Your obligations to the Company under these Terms and Conditions shall not be affected, waived, or reduced by any claim you may have against a merchant. You shall be solely responsible for resolving any disputes with merchants. In particular, you and the merchant must agree to establish, modify, or terminate any automatic transfer or direct debit arrangement for charging payments to your account. In the event of any dispute between you and the merchant, the Company reserves the right not to execute any request to establish, modify, or terminate such arrangements.</p>
<p>22.Even if any merchant fails to provide goods or services or fails to fulfill its obligations, or if any goods or services provided by any merchant are defective, or if any merchant fails to provide you with any goods, services, offers, discounts, or programs, the Company reserves the right to deduct from your account all transactions made using your charge card or authentication factors. You must seek redress directly from the relevant merchant regarding such goods, services, offers, discounts, or programs.</p>
<p>23.	The Company reserves the right to convert the refund amount into another currency at a time and exchange rate deemed appropriate by the Company. You shall bear all related exchange rate risks, losses, commissions, and other charges and fees.</p>
<p>24.	Under no circumstances shall the Company, its affiliates, service providers, or any of their respective officers, directors, agents, partners, employees, or representatives be liable for:<br>
a)	Any loss of profits, goodwill or reputation, loss of data, impairment of value or business opportunities, loss, damage, deterioration, or disclosure of any data or other intangible property, or any special, incidental, indirect, intangible, or consequential damages arising out of or in connection with the use of the Company's website or services or this Agreement, whether based on contract, tort, negligence, strict liability, or otherwise, even if the Company has been advised of, knew of, or ought to have known of the possibility of such damages, and even if any agreed-upon or other remedy fails of its essential purpose. The Company shall not be liable for such damages unless a final judicial determination establishes that such damages resulted from the Company's gross negligence, fraud, or intentional misconduct, or intentional violation of law.
This means, for example (and without limiting the foregoing), if you claim that the Company failed to properly execute a trade, your damages are limited to the lesser of the amount involved in the trade or the balance of the cash sub-account associated with your trust account; and you may not recover damages for lost profits, lost business opportunities, diminished value, or any other special, incidental, indirect, intangible, punitive, or consequential damages, or any other losses. We shall not be liable for damages arising from or related to unsupported currencies. Certain jurisdictions do not permit the exclusion or limitation of incidental or consequential damages, so the above limitations may not apply to you.
</p>
<p><strong>Governing Law and Dispute Resolution</strong></p>
<p>25.	These terms shall be governed by and construed in accordance with the laws of Hong Kong, without regard to its conflict of laws principles.</p>
<p>26.	If you are a consumer and have any complaints, we encourage you to first contact our customer service team via our website www.hongkongtrust.com.hk and email info@hktcm.com.</p>
<p>27.	If the complaint is not resolved to your satisfaction, you may refer the matter to the Hong Kong Mediation and Arbitration Centre for mediation, followed by arbitration at the Hong Kong International Arbitration Centre in accordance with its then-current Arbitration Rules (“HKIAC Rules”). Should mediation fail, such rules shall be deemed incorporated by reference into these Terms.</p>
<p>28.	The language of the arbitration shall be English. The place of arbitration shall be Hong Kong. Unless otherwise determined by the arbitral tribunal, each party shall bear its own arbitration costs.</p>
</div>
        <div class="terms-footer">
          <div class="terms-checkbox">
            <input type="checkbox" id="termsAgree" v-model="termsAgreed" :disabled="!canAgree">
            <label for="termsAgree" class="terms-checkbox-label">
              I confirm that I have read and agree to the 'HKTCM Global Visa Charge Card Terms and Conditions.'<br>
              <span>Please check this box to confirm you have read and agree to the terms before proceeding with the application.</span>
            </label>
          </div>
          <div class="terms-actions">
            <el-button @click="closeTermsDialog" class="terms-cancel">Cancel</el-button>
            <el-button @click="acceptTerms" :disabled="!termsAgreed" class="terms-accept">Accept</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 申請表單彈窗 -->
      <el-dialog :visible.sync="applicationFormVisible" title="Credit Card Application Form" class="application-form-dialog" width="950px" append-to-body>
        <div class="step-nav">
          <div class="step">
            <div class="step-number" :class="{ 'active': currentStep === 1 }">1</div>
            <div class="step-label" :class="{ 'active': currentStep === 1 }">Applicant & Account</div>
          </div>
          <div class="step-connector" :class="{ 'active': currentStep >= 2 }"></div>
          <div class="step">
            <div class="step-number" :class="{ 'active': currentStep === 2 }">2</div>
            <div class="step-label" :class="{ 'active': currentStep === 2 }">Cardholder Information</div>
          </div>
        </div>
        <div v-if="currentStep === 1" class="form-section">
          <h3 class="section-title">Applicant and Trust Account Information</h3>
          <div class="preview-title" style="margin-bottom: 20px;">
            Applicant: {{ formData.Name }}
          </div>
          <div class="form-group">
            <label class="form-label">Trust account number</label>
            <el-input v-model="formData.username" readonly class="form-input readonly-input"></el-input>
          </div>
          <div class="part-a-grid" style="margin-top: 20px;">
            
            <div class="form-group">
              <label class="form-label">Name</label>
              <el-input v-model="formData.Name" placeholder="Please enter your name" class="form-input readonly-input" readonly></el-input>
            </div>

            <div class="form-group">
              <label class="form-label">Gender</label>
              <el-select v-model="formData.gender" placeholder="Please select" class="form-input title-select readonly-input" readonly>
                <el-option label="male" value="male"></el-option>
                <el-option label="female" value="female"></el-option>
              </el-select>
            </div>
            <!-- <div class="form-group">
              <label class="form-label">姓氏</label>
              <el-input v-model="formData.lastName" placeholder="請輸入姓氏" class="form-input readonly-input" readonly></el-input>
            </div> -->
          </div>
          <div class="part-a-grid" style="margin-top: 20px;">
            <div class="form-group">
              <label class="form-label">Nationality</label>
              <el-input v-model="formData.nationality" placeholder="Please enter your nationality" class="form-input readonly-input" readonly></el-input>
            </div>
            <div class="form-group">
              <label class="form-label">National Identity Card Number/Passport</label>
              <el-input v-model="formData.idNumber" placeholder="Please enter your identification number" class="form-input readonly-input" readonly></el-input>
            </div>
          </div>
          <div class="part-a-grid" style="margin-top: 20px;">
            <div class="form-group">
              <label class="form-label">telephone</label>
              <el-input v-model="formData.phone" placeholder="Please enter your contact telephone number" class="form-input required-input"></el-input>
            </div>
            <div class="form-group">
              <label class="form-label">Email address</label>
              <el-input v-model="formData.email" placeholder="Please enter your email address" type="email" class="form-input required-input"></el-input>
            </div>
          </div>
          <div class="form-group" style="margin-top: 20px;">
            <label class="form-label">Postal address</label>
            <el-input v-model="formData.address" type="textarea" :rows="3" placeholder="Please enter your full postal address" class="form-input large-input required-input"></el-input>
          </div>
        </div>
        <div v-if="currentStep === 2" class="form-section">
          <h3 class="section-title">Account Card Distribution Information</h3>
          <div style="font-size: 14px; margin-bottom: 20px; color: var(--text-secondary);">
            Account cards will be issued to (name must not exceed 20 characters, including spaces)
          </div>
          <!-- 主卡 -->
          <div style="margin-bottom: 25px;">
            <div style="font-weight: bold; margin-bottom: 8px;">Name on the account card</div>
            <div style="font-size: 13px; color: var(--text-secondary); margin-bottom: 8px;">
              Names must be provided in English only (e.g., John Smith). Chinese characters, numbers, or special symbols are not permitted.
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
              <span style="min-width: 100px;">Primary cardholder:</span>
              <div style="flex: 1; position: relative;">
                <el-input
                  v-model="formData.cardName1"
                  @input="handleCardName1Input"
                  placeholder="Please enter English name only (e.g. John Smith)"
                  class="form-input"
                  :class="{ 'required-input': formData.cardName1 && formData.cardName1.trim() }"
                ></el-input>
                <span class="char-counter" :class="getCharCountClass(formData.cardName1 ? formData.cardName1.length : 0)"
                  style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">
                  {{ formData.cardName1 ? formData.cardName1.length : 0 }}/20
                </span>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
              <span>Application Category:</span>
              <template v-for="option in availableCardTypes" >
                <label :key="option.value" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
                  <input type="radio" v-model="formData.cardType1" :value="option.value" :name="'cardType1'"> {{ option.label }}
                </label>
              </template>
            </div>
            <div v-if="formData.cardType1" class="card-preview">
              <img :src="getCardImage(formData.cardType1)" alt="Credit Card Preview" />
              <img v-if="formData.showLogoOnCard1" :src="getLogoImage(formData.cardType1)" alt="HKTCM Logo" class="logo-overlay" />
              <div v-if="formData.showNameOnCard1" class="name-overlay"
              :style="{ color: formData.cardType1 === 'black' ? '#d6c6a4' : '#000000' }">{{ formData.cardName1 || 'YOUR NAME' }}</div>
            </div>
            <div v-if="formData.cardType1" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showNameOnCard1"> Display cardholder's name
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showLogoOnCard1"> Display bank logo
              </label>
            </div>
          </div>
          <!-- 添加附属卡按钮 -->
          <div style="margin-bottom: 20px;">
            <el-button
              type="text"
              @click="toggleCard2"
              style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;"
            >
              {{ formData.showCard2 ? '▲ Close supplementary card' : '➕ Add an additional card' }}
            </el-button>
          </div>
          <!-- 附属卡 1 -->
          <div v-if="formData.showCard2" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
            <div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
              <span style="min-width: 100px;">Supplementary cardholder:</span>
              <div style="flex: 1; position: relative;">
                <el-input
                  v-model="formData.cardName2"
                  @input="handleCardName2Input"
                  placeholder="Please enter English name only (e.g. Jane Doe)"
                  class="form-input"
                  :class="{ 'required-input': formData.cardName2 && formData.cardName2.trim() }"
                ></el-input>
                <span class="char-counter" :class="getCharCountClass(formData.cardName2 ? formData.cardName2.length : 0)"
                  style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">
                  {{ formData.cardName2 ? formData.cardName2.length : 0 }}/20
                </span>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span>Gender:</span>
              <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                <input type="radio" v-model="formData.gender2" value="male" name="gender2"> male
              </label>
              <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                <input type="radio" v-model="formData.gender2" value="female" name="gender2"> female
              </label>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Nationality:</span>
              <el-select
                v-model="formData.nationality2"
                filterable
                placeholder="Please select your nationality"
                class="form-input"
                style="flex:1;"
              >
                <el-option
                  v-for="country in countryList"
                  :key="country.code"
                  :label="country.name"
                  :value="country.name"
                />
              </el-select>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Document Number:</span>
              <el-input v-model="formData.idNumber2" placeholder="National Identity Card or Passport Number" class="form-input" style="flex:1;"></el-input>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Upload documents:</span>
              <el-upload
              action="#"
              :file-list="formData.idDocFileList2"
              :on-change="(file) => goToUpload(file, 'idDocUrl2', 'idDocFileList2')"
              :auto-upload="false"
              :limit="1"
              accept=".jpg,.png,.pdf"
            >
              <el-button size="small" type="primary">Select file</el-button>
              
            </el-upload>
            <span style="min-width: 80px;">The file size must not exceed 5MB.</span>
            </div>
            <div style="display: flex; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <div style="display: flex; gap: 8px; flex:1;">
                <el-select
                  v-model="formData.phoneCode2"
                  filterable
                  placeholder="Area code"
                  style="width: 120px;"
                  class="form-input"
                  :key="formData.phoneCode2"
                >
                  <el-option label="+852 Hong Kong" value="+852" />
                  <el-option label="+86 China" value="+86" />
                  <el-option label="+886 Taiwan" value="+886" />
                  <el-option label="+1 United States/Canada" value="+1" />
                  <el-option label="+81 Japan" value="+81" />
                  <el-option label="+44 United Kingdom" value="+44" />
                  <el-option label="+61 Australia" value="+61" />
                  <el-option label="+49 Germany" value="+49" />
                  <el-option label="+33 France" value="+33" />
                </el-select>
                <el-input
                  v-model="formData.phone2"
                  @input="handlePhoneInput(2, $event.target.value)"
                  placeholder="Numbers only, no symbols"
                  class="form-input"
                  style="flex:1;"
                ></el-input>
              </div>
              <el-input v-model="formData.email2" placeholder="Email address" type="email" class="form-input" style="flex:1;"></el-input>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
              <span>Application Category:</span>
              <template v-for="option in availableCardTypes" >
                <label :key="`2-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
                  <input type="radio" v-model="formData.cardType2" :value="option.value" :name="'cardType2'"> {{ option.label }}
                </label>
              </template>
            </div>
            <div v-if="formData.cardType2" class="card-preview">
              <img :src="getCardImage(formData.cardType2)" alt="Credit Card Preview" />
              <img v-if="formData.showLogoOnCard2" :src="getLogoImage(formData.cardType2)" alt="HKTCM Logo" class="logo-overlay" />
              <div v-if="formData.showNameOnCard2" class="name-overlay"
              :style="{ color: formData.cardType2 === 'black' ? '#d6c6a4' : '#000000' }">{{ formData.cardName2 || 'YOUR NAME' }}</div>
            </div>
            <div v-if="formData.cardType2" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showNameOnCard2"> Display cardholder's name
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showLogoOnCard2"> Display bank logo
              </label>
            </div>
          </div>
          <!-- 添加第二张附属卡 -->
          <div v-if="formData.showCard2" style="margin-bottom: 20px;">
            <el-button
              type="text"
              @click="toggleCard3"
              style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;"
            >
              {{ formData.showCard3 ? '▲ Retract the second supplementary card' : '➕ Add a second supplementary card' }}
            </el-button>
          </div>
          <!-- 附属卡 2 -->
          <div v-if="formData.showCard3" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
            <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
              <span style="min-width: 100px;">Supplementary cardholder:</span>
              <div style="flex: 1; position: relative;">
                <el-input
                  v-model="formData.cardName3"
                  @input="handleCardName3Input"
                  placeholder="Please enter English name only"
                  class="form-input"
                  :class="{ 'required-input': formData.cardName3 && formData.cardName3.trim() }"
                ></el-input>
                <span class="char-counter" :class="getCharCountClass(formData.cardName3 ? formData.cardName3.length : 0)"
                  style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">
                  {{ formData.cardName3 ? formData.cardName3.length : 0 }}/20
                </span>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span>Gender:</span>
              <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                <input type="radio" v-model="formData.gender3" value="male" name="gender3"> male
              </label>
              <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                <input type="radio" v-model="formData.gender3" value="woman" name="gender3"> woman
              </label>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Nationality:</span>
              <el-select
                v-model="formData.nationality3"
                filterable
                placeholder="Please select your nationality"
                class="form-input"
                style="flex:1;"
              >
                <el-option
                  v-for="country in countryList"
                  :key="country.code"
                  :label="country.name"
                  :value="country.name"
                />
              </el-select>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Document Number:</span>
              <el-input v-model="formData.idNumber3" placeholder="National Identity Card or Passport Number" class="form-input" style="flex:1;"></el-input>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <span style="min-width: 80px;">Upload documents:</span>
              <el-upload
              action="#"
              :file-list="formData.idDocFileList3"
              :on-change="(file) => goToUpload(file, 'idDocUrl3', 'idDocFileList3')"
              :auto-upload="false"
              :limit="1"
              accept=".jpg,.png,.pdf"
            >
              <el-button size="small" type="primary">Select file</el-button>
            </el-upload>
            <span style="color: #909399; font-size: 12px;">The file size must not exceed 5MB.</span>
            </div>
            <div style="display: flex; gap: 16px; margin-left: 100px; margin-bottom: 12px;">
              <div style="display: flex; gap: 8px; flex:1;">
                <el-select
                  v-model="formData.phoneCode3"
                  filterable
                  placeholder="Area code"
                  style="width: 120px;"
                  class="form-input"
                  :key="formData.phoneCode3" 
                >
                  <el-option label="+852 Hong Kong" value="+852" />
                  <el-option label="+86 China" value="+86" />
                  <el-option label="+886 Taiwan" value="+886" />
                  <el-option label="+1 United States/Canada" value="+1" />
                  <el-option label="+81 Japan" value="+81" />
                  <el-option label="+44 United Kingdom" value="+44" />
                  <el-option label="+61 Australia" value="+61" />
                  <el-option label="+49 Germany" value="+49" />
                  <el-option label="+33 France" value="+33" />
                </el-select>
                <el-input
                  v-model="formData.phone3"
                  @input="handlePhoneInput(3, $event.target.value)"
                  placeholder="Numbers only, no symbols"
                  class="form-input"
                  style="flex:1;"
                ></el-input>
              </div>
              <el-input v-model="formData.email3" placeholder="Email address" type="email" class="form-input" style="flex:1;"></el-input>
            </div>
            <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px;">
              <span>Application Category:</span>
              <template v-for="option in availableCardTypes" >
                <label :key="`3-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
                  <input type="radio" v-model="formData.cardType3" :value="option.value" :name="'cardType3'"> {{ option.label }}
                </label>
              </template>
            </div>
            <div v-if="formData.cardType3" class="card-preview">
              <img :src="getCardImage(formData.cardType3)" alt="Credit Card Preview" />
              <img v-if="formData.showLogoOnCard3" :src="getLogoImage(formData.cardType3)" alt="HKTCM Logo" class="logo-overlay" />
              <div v-if="formData.showNameOnCard3" class="name-overlay"
              :style="{ color: formData.cardType3 === 'black' ? '#d6c6a4' : '#000000' }">{{ formData.cardName3 || 'YOUR NAME' }}</div>
            </div>
            <div v-if="formData.cardType3" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showNameOnCard3"> Display cardholder's name
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="checkbox" v-model="formData.showLogoOnCard3"> Display bank logo
              </label>
            </div>
          </div>
        </div>
        <div class="form-footer" slot="footer">
          <el-button v-if="currentStep > 1" @click="prevStep" class="form-btn btn-prev">Previous step</el-button>
          <el-button v-if="currentStep < 2" @click="nextStep" class="form-btn btn-next">Next step</el-button>
          <el-button v-if="currentStep === 2" type="primary" @click="submitApplication" class="form-btn btn-submit">Submit an application</el-button>
        </div>
      </el-dialog>

      <!-- 预览确认副表单 -->
      <el-dialog :visible.sync="previewVisible" title="Application Information Preview" width="800px" :append-to-body="true">
        <div v-if="previewData" class="preview-content">
          <h3 style="text-align: center; margin-bottom: 20px;">HKTCM Credit Card Application Form</h3>
          <h4 class="section-title">Applicant Information</h4>
          <table class="preview-table">
            <tr><th>Trust account number:</th><td>{{ previewData.trustAccount || 'N/A' }}</td></tr>
            <tr><th>Name:</th><td>{{ previewData.Name }}</td></tr>
            <tr><th>Gender:</th><td>{{ previewData.gender }}</td></tr>
            <tr><th>Nationality:</th><td>{{ previewData.nationality || 'N/A' }}</td></tr>
            <tr><th>National Identity Card Number/Passport:</th><td>{{ previewData.idNumber || 'N/A' }}</td></tr>
            <tr><th>telephone:</th><td>{{ previewData.phone || 'N/A' }}</td></tr>
            <tr><th>Email address:</th><td>{{ previewData.email || 'N/A' }}</td></tr>
            <tr><th>Postal address:</th><td>{{ previewData.address || 'N/A' }}</td></tr>
          </table>
          <h4 class="section-title">Account Card Distribution Information</h4>
          <table class="preview-table">
            <!-- 主卡 -->
            <tr><th>Primary Cardholder's Name:</th><td>{{ previewData.cardName1 || 'N/A' }}</td></tr>
            <tr><th>Application Category:</th><td>{{ previewData.cardType1 ? cardTypeLabels[previewData.cardType1] : 'N/A' }}</td></tr>
            <tr><th>Primary Card - Display Cardholder Name:</th><td>{{ boolToText(previewData.showNameOnCard1) }}</td></tr>
            <tr><th>Primary Card - Display Bank Logo:</th><td>{{ boolToText(previewData.showLogoOnCard1) }}</td></tr>
            <!-- 附属卡 1 -->
            <template v-if="previewData.cardName2 && previewData.cardName2.trim()">
              <tr><th>Supplementary Card 1 Name:</th><td>{{ previewData.cardName2 }}</td></tr>
              <tr><th>Nationality:</th><td>{{ previewData.nationality2 || 'N/A' }}</td></tr>
              <tr><th>Gender:</th><td>{{ previewData.gender2 || 'N/A' }}</td></tr>
              <tr><th>Document number:</th><td>{{ previewData.idNumber2 || 'N/A' }}</td></tr>
              <tr><th>telephone:</th><td>{{ previewData.phone2 || 'N/A' }}</td></tr>
              <tr><th>Email address:</th><td>{{ previewData.email2 || 'N/A' }}</td></tr>
              <tr><th>Application Category:</th><td>{{ previewData.cardType2 ? cardTypeLabels[previewData.cardType2] : 'N/A' }}</td></tr>
              <tr><th>Supplementary Card 1 - Display cardholder's name:</th><td>{{ boolToText(previewData.showNameOnCard2) }}</td></tr>
              <tr><th>Supplementary Card 1 - Display Bank Logo:</th><td>{{ boolToText(previewData.showLogoOnCard2) }}</td></tr>
            </template>
            <!-- 附属卡 2 -->
            <template v-if="previewData.cardName3 && previewData.cardName3.trim()">
              <tr><th>Supplementary Card 2 Name:</th><td>{{ previewData.cardName3 }}</td></tr>
              <tr><th>Nationality:</th><td>{{ previewData.nationality3 || 'N/A' }}</td></tr>
              <tr><th>Gender:</th><td>{{ previewData.gender3 || 'N/A' }}</td></tr>
              <tr><th>Document number:</th><td>{{ previewData.idNumber3 || 'N/A' }}</td></tr>
              <tr><th>telephone:</th><td>{{ previewData.phone3 || 'N/A' }}</td></tr>
              <tr><th>Email address:</th><td>{{ previewData.email3 || 'N/A' }}</td></tr>
              <tr><th>Application Category:</th><td>{{ previewData.cardType3 ? cardTypeLabels[previewData.cardType3] : 'N/A' }}</td></tr>
              <tr><th>Supplementary Card 2 - Display cardholder's name:</th><td>{{ boolToText(previewData.showNameOnCard3) }}</td></tr>
              <tr><th>Supplementary Card 2 - Display Bank Logo:</th><td>{{ boolToText(previewData.showLogoOnCard3) }}</td></tr>
            </template>
          </table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="previewVisible = false">Return to edit</el-button>
          <el-button type="primary" @click="confirmAndSubmit">Confirm and submit</el-button>
        </div>
      </el-dialog>

      <!-- ✅ 批核查询弹窗 -->
      <el-dialog :visible.sync="queryVisible" title="Check the approval status" width="450px" class="query-dialog">
        <el-form :model="queryForm" label-position="left" label-width="100px">
          <el-form-item label="Methods:">
            <el-radio-group v-model="queryForm.type">
              <el-radio label="trust">Trust</el-radio>
              <el-radio label="id">Document Number</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="queryForm.type === 'trust' ? 'Trust:' : 'Document:'">
            <el-input v-model="queryForm.value" class="login-input"></el-input>
          </el-form-item>
          <el-form-item label="ImageCap:">
            <div style="display: flex; align-items: center; gap: 10px;">
              <el-input v-model="queryForm.captchaInput" placeholder="Enter code" style="width: 160px;"></el-input>
              <canvas ref="captchaCanvas" width="100" height="40" style="border:1px solid #ddd; cursor:pointer;" @click="generateCaptcha"></canvas>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="queryVisible = false">Cancel</el-button>
          <el-button type="primary" @click="handleQuery">Enquiry</el-button>
        </div>
      </el-dialog>

      <!-- ✅ 批核详情页 -->
      <el-dialog :visible.sync="detailVisible" title="Application Progress Details" width="700px" append-to-body>
        <div v-if="currentApplication">
          <div class="form-section">
            <h3 class="section-title">Application Basic Information</h3>
            <table class="preview-table">
              <tr><th>Application Number</th><td>{{ currentApplication.appNo }}</td></tr>
              <tr><th>Apply for the product</th><td>{{ currentApplication.product }}</td></tr>
              <tr><th>Application period</th><td>{{ currentApplication.submitTime }}</td></tr>
            </table>
          </div>
          <div class="form-section">
            <h3 class="section-title">Application Progress</h3>
            <el-steps :active="currentApplication.stepIndex" finish-status="success" simple>
              <el-step title="Application submission" :description="currentApplication.submitTime"></el-step>
              <el-step title="Data Verification" description="Expected completion within two working days"></el-step>
              <el-step title="Credit rating" description="Internal risk control approval"></el-step>
              <el-step title="Approval outcome" :description="getFinalStatusDesc(currentApplication.status)"></el-step>
            </el-steps>
          </div>
          <div class="form-section">
            <h3 class="section-title">Approval status</h3>
            <p><strong>Current status:</strong><span :style="{ color: getStatusColor(currentApplication.status) }">{{ getStatusText(currentApplication.status) }}</span></p>
            <div v-if="currentApplication.status === 'pending_docs'" style="background:#fff8e1; padding:12px; border-left:4px solid #F59E0B; margin-top:10px;">
              <strong>⚠️ Reminder for supplementary documents:</strong>{{ currentApplication.missingDocs }}
            </div>
            <div v-if="currentApplication.status === 'approved' && currentApplication.trackingNumber" class="form-section">
              <p><strong>Parcel tracking number:</strong>{{ currentApplication.trackingNumber }}
                <a :href="currentApplication.trackingUrl" target="_blank" style="color: var(--primary-color); margin-left:10px;">View logistics</a>
              </p>
            </div>
          </div>
          <div v-if="currentApplication.status === 'approved'" class="form-section">
            <h3 class="section-title">Card Configuration</h3>
            <table class="preview-table">
              <tr><th>Credit limit</th><td>{{ currentApplication.creditLimit }}</td></tr>
              <tr><th>Statement date / Repayment date</th><td>{{ currentApplication.billingDay }} / {{ currentApplication.repaymentDay }}</td></tr>
            </table>
            <div v-if="currentApplication.subCards.length > 0" style="margin-top:15px;">
              <h4 style="font-weight:bold; margin-bottom:8px;">List of Supplementary Cards</h4>
              <div v-for="(sub, idx) in currentApplication.subCards" :key="idx" style="padding:10px; background:#f9fafb; border-radius:6px; margin-bottom:8px;">
                <span>Cardholder:{{ sub.name }}｜Status:{{ sub.status === 'approved' ? 'Approved' : 'Not approved' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailVisible = false">Close</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import 'element-ui/lib/theme-chalk/index.css';
import {
  Dialog, Form, FormItem, Input, Button, Select, Option, RadioGroup, Radio,
  Upload, Steps, Step
} from 'element-ui';

export default {
  name: 'CreditCard',
  components: {
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Upload.name]: Upload,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
  data() {
    return {

      // 附属卡 1 附件相关
      idDocFileList2: [], // 控制 Upload 组件显示
      idDocUrl2: '',      // 存储上传成功后的 URL
      
      // 附属卡 2 附件相关
      idDocFileList3: [],
      idDocUrl3: '',
      // 国家与区号数据
      countryList: [
        { code: 'CN', name: 'China' },
        { code: 'US', name: 'United States' },
        { code: 'JP', name: 'Japan' },
        { code: 'GB', name: 'United Kingdom' },
        { code: 'CA', name: 'Canada' },
        { code: 'AU', name: 'Australia' },
        { code: 'DE', name: 'Germany' },
        { code: 'FR', name: 'France' },
        { code: 'SG', name: 'Singapore' },
        { code: 'KR', name: 'South Korea' },
        { code: 'TW', name: 'Taiwan' },
        { code: 'HK', name: 'Hong Kong' },
        { code: 'MO', name: 'Macau' },
        { code: 'MY', name: 'Malaysia' },
        { code: 'TH', name: 'Thailand' },
        { code: 'ID', name: 'Indonesia' },
        { code: 'PH', name: 'Philippines' },
        { code: 'VN', name: 'Vietnam' },
        { code: 'IN', name: 'India' },
        { code: 'RU', name: 'Russia' },
        { code: 'BR', name: 'Brazil' },
        { code: 'MX', name: 'Mexico' },
        { code: 'ZA', name: 'South Africa' },
        { code: 'EG', name: 'Egypt' },
        { code: 'SA', name: 'Saudi Arabia' },
        { code: 'AE', name: 'United Arab Emirates' },
        { code: 'IL', name: 'Israel' },
        { code: 'TR', name: 'Turkey' },
        { code: 'IT', name: 'Italy' },
        { code: 'ES', name: 'Spain' },
        { code: 'NL', name: 'Netherlands' },
        { code: 'SE', name: 'Sweden' },
        { code: 'NO', name: 'Norway' },
        { code: 'FI', name: 'Finland' },
        { code: 'DK', name: 'Denmark' },
        { code: 'CH', name: 'Switzerland' },
        { code: 'AT', name: 'Austria' },
        { code: 'BE', name: 'Belgium' },
        { code: 'PL', name: 'Poland' },
        { code: 'CZ', name: 'Czech Republic' },
        { code: 'HU', name: 'Hungary' },
        { code: 'GR', name: 'Greece' },
        { code: 'PT', name: 'Portugal' },
        { code: 'IE', name: 'Ireland' },
        { code: 'NZ', name: 'New Zealand' },
        { code: 'AR', name: 'Argentina' },
        { code: 'CL', name: 'Chile' },
        { code: 'CO', name: 'Colombia' },
        { code: 'PE', name: 'Peru' },
        { code: 'VE', name: 'Venezuela' }

      ],
      // 登录验证模块
      loginVisible: false,
      countdown: 0, // 👈 必须初始化为 0
      countdownTimer: null, // 用于清除定时器
      loginForm: {
        clientCode: '',
        password: '',
        areaCode: '+86', // 👈 新增默认区号
        phone: '',
        verificationCode: ''
      },
      countdown: 0,
      countdownTimer: null,

      currentUserInfo: null,
      // 条款及细则模块
      termsVisible: false,
      termsAgreed: false,
      canAgree: false,
      // 申请表单模块
      applicationFormVisible: false,
      currentStep: 1,
      previewVisible: false,
      previewData: null,
      formData: {
        title: '', firstName: '', lastName: '', address: '', nationality: '',
        idNumber: '', phone: '', email: '', trustAccount: '',
        cardName1: '', cardType1: '',
        showNameOnCard1: true, showLogoOnCard1: true,
        cardName2: '', gender2: '', nationality2: '', idNumber2: '', phone2: '', email2: '', cardType2: '',
        showNameOnCard2: true, showLogoOnCard2: true,
        idDocFileList2: [],
        cardName3: '', gender3: '', nationality3: '', idNumber3: '', phone3: '', email3: '', cardType3: '',
        showNameOnCard3: true, showLogoOnCard3: true,
        idDocFileList3: [],
        showCard2: false,
        showCard3: false,
        phoneCode2: '+852',
        phoneCode3: '+852'
      },
      cardTypeLabels: { gold: 'Gold Card', platinum: 'Platinum Card', black: 'Black Card' },
      // 批核查询模块
      queryVisible: false,
      detailVisible: false,
      queryForm: {
        type: 'trust',
        value: '',
        captchaInput: ''
      },
      captchaCode: '',
      currentApplication: null,
      approvalDatabase: [
        {
          appNo: 'APP20260115A',
          trustAccount: 'C123456',
          idNumber: 'A123456(7)',
          product: 'GFOA 专属信托金卡',
          submitTime: '2026-01-10 14:30',
          status: 'reviewing',
          stepIndex: 1,
          missingDocs: '',
          trackingNumber: '',
          trackingUrl: '',
          creditLimit: 'HKD 200,000',
          billingDay: '每月 15 日',
          repaymentDay: '每月 30 日',
          subCards: [{ name: '張小偉', status: 'approved' }]
        },
        {
          appNo: 'APP20260114B',
          trustAccount: 'C789012',
          idNumber: 'P78901234',
          product: 'GFOA 黑卡',
          submitTime: '2026-01-09 10:15',
          status: 'pending_docs',
          stepIndex: 1,
          missingDocs: '缺附属卡身份证件正反面及住址證明',
          trackingNumber: '',
          trackingUrl: '',
          creditLimit: '',
          billingDay: '',
          repaymentDay: '',
          subCards: []
        }
      ]
    };
  },
  computed: {
    availableCardTypes() {
  // 1. 定义映射关系：数字 ID 对应前端使用的 Value
  const cardMap = {
    1: 'gold',
    2: 'platinum',
    3: 'black'
  };
  

  // 2. 定义原始选项
  const allCardOptions = [
    { value: 'gold', label: 'Gold Card', id: 1, visible: false },
    { value: 'platinum', label: 'Platinum Card', id: 2, visible: false },
    { value: 'black', label: 'Black Card', id: 3, visible: false }
  ];

  // 3. 检查权限并修改可见性
  // 注意：这里我们使用 this.formData.allowedCards，因为你在 loadCustomerData 已经同步过来了
  // 如果想直接用接口原始数据，可以用 this.currentUserInfo.allowedCards
  const allowed = this.formData.allowedCards || [];

  allCardOptions.forEach(option => {
    // 核心逻辑：判断选项的 id (数字) 是否在后端返回的数组里
    option.visible = allowed.includes(option.id);
  });

  return allCardOptions;
}
  },
  methods: {
    

sendVerificationCode() {
  const { clientCode, password, phone, areaCode } = this.loginForm;

  // 1. 前端基本验证
  if (!clientCode || !password || !phone) {
    this.$message.warning('Please enter ID, password and phone number.');
    return;
  }
  
  // 校验手机号格式（数字即可）
  if (!/^\d+$/.test(phone)) {
    this.$message.warning('Invalid phone number.');
    return;
  }

  // 防止重复点击
  if (this.countdown > 0) return;

  // 2. 构造数据
  const postData = {
    username: clientCode,
    password: password,
    phone: phone,
    area_code: areaCode || '+86',
    captcha_req: 1
  };

  // 3. 调用接口并直接启动倒计时
  axios.post('/api/verify.php', qs.stringify(postData))
    .then(res => {
      // 只要进入 then，说明网络请求通了
      this.$message.success('Verification code sent!');
      
      // 立即进入倒计时状态
      this.countdown = 60;
      
      // 确保之前的定时器被清理
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    })
    .catch(err => {
      console.error(err);
      this.$message.error('Failed to send code. Please check your network.');
    });
},
openLoginDialog(type) {
       this.loginVisible = true;
    },
// 登录验证（第二次请求：提交 账号+密码+手机+验证码）
handleLogin() {
  const { clientCode, password, phone, verificationCode } = this.loginForm;

  if (!clientCode || !password || !phone || !verificationCode) {
    this.$message.error('Please complete all fields.');
    return;
  }

  const postData = {
    username: clientCode,
    password: password,
    phone: phone,
    code: verificationCode
  };

  axios.post('/api/verify.php', qs.stringify(postData))
    .then(res => {
      // 这里的逻辑根据你提供的 JSON 结构进行适配
      if (res.data && res.data.status === 1) {
        this.$message.success('Login successful!');

        // 核心：获取内层的 data 对象
        const userData = res.data.data;

        // 直接将接口数据映射到表单对象 formData
        this.formData.username = userData.username;
        this.formData.Name = userData.name;
        this.formData.gender = userData.gender;
        this.formData.title = userData.title;
        this.formData.phone = userData.phone;
        this.formData.address = userData.address;
        this.formData.nationality = userData.nationality;
        this.formData.idNumber = userData.idNumber;
        this.formData.email = userData.email;
        
        // 存储卡片权限数据 (gold)
        this.formData.allowedCards = userData.gold; 

        // 保存用户信息以便后续 openTermsDialog 调用
        this.currentUserInfo = userData; 

        this.loginVisible = false;
        
        // 自动跳转到条款弹窗
        this.openTermsDialog('existing');
      } else {
        // 如果 status 不为 1，显示后端返回的错误消息
        this.$message.error('Login failed:' + (res.data.message || 'Information mismatch'));
      }
    })
    .catch(err => {
      console.error(err);
      this.$message.error('Login request error. Please check your network settings.');
    });
},
    openTermsDialog(type) {
      this.termsVisible = true;
      this.termsAgreed = false;
      this.canAgree = false;
      this.$nextTick(() => {
        if (this.$refs.termsContentRef) this.$refs.termsContentRef.scrollTop = 0;
      });
      if (type === 'existing' && this.currentUserInfo) {
        this.loadCustomerData();
      }
    },
    closeTermsDialog() {
      this.termsVisible = false;
      this.termsAgreed = false;
      this.canAgree = false;
    },
    handleTermsScroll(event) {
      const el = event.target;
      this.canAgree = (el.scrollHeight - el.scrollTop <= el.clientHeight + 5);
    },
    acceptTerms() {
      if (this.termsAgreed) {
        this.termsVisible = false;
        this.applicationFormVisible = true;
        this.currentStep = 1;
        if (this.currentUserInfo && !this.formData.trustAccount) {
          this.loadCustomerData();
        }
      }
    },

    
   loadCustomerData() {
  if (this.currentUserInfo) {
    const info = this.currentUserInfo;

    // 基础资料映射
    this.formData.username = info.username || '';
    this.formData.trustAccount = info.username || ''; // 假设用 username 作为信托账号
    this.formData.Name = info.name || '';
    this.formData.title = info.title || '';
    this.formData.gender = info.gender || '';
    this.formData.phone = info.phone || '';
    this.formData.address = info.address || '';
    this.formData.nationality = info.nationality || '';
    this.formData.idNumber = info.idNumber || '';
    this.formData.email = info.email || '';

    // 核心修改：映射数组格式的权限
    // 此时 info.allowedCards 是 [1, 2, 3]
    this.formData.allowedCards = Array.isArray(info.allowedCards) ? info.allowedCards : [];

    console.log('Permissions array loaded successfully:', this.formData.allowedCards);
  } else {
    this.$message.error('No customer information found. Please log in again.');
  }
},





    // 手机号处理
    handlePhoneInput(cardIndex, value) {
      const cleanValue = value.replace(/\D/g, ''); // 仅保留数字
      if (cardIndex === 2) {
        this.$set(this.formData, 'phone2', cleanValue); // Vue 2 确保响应式
      } else if (cardIndex === 3) {
        this.$set(this.formData, 'phone3', cleanValue); // Vue 2 确保响应式
      }
    },

    // 批核查询相关方法
    openQueryDialog() {
      this.queryVisible = true;
      this.queryForm = { type: 'trust', value: '', captchaInput: '' };
      this.$nextTick(() => {
        this.generateCaptcha();
      });
    },
    generateCaptcha() {
      const code = Math.floor(1000 + Math.random() * 9000).toString();
      this.captchaCode = code;
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = '24px Arial';
      ctx.fillStyle = '#333';
      ctx.fillText(code, 15, 30);
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgb(${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)})`;
        ctx.beginPath();
        ctx.moveTo(Math.random()*100, Math.random()*40);
        ctx.lineTo(Math.random()*100, Math.random()*40);
        ctx.stroke();
      }
    },
    handleQuery() {
      if (!this.queryForm.value.trim()) {
        this.$message.warning('Please enter your search criteria');
        return;
      }
      if (!this.queryForm.captchaInput.trim()) {
        this.$message.warning('Please enter the CAPTCHA');
        return;
      }
      if (this.queryForm.captchaInput !== this.captchaCode) {
        this.$message.error('Graphical CAPTCHA error');
        this.generateCaptcha();
        return;
      }

      let record = null;
      if (this.queryForm.type === 'trust') {
        record = this.approvalDatabase.find(item => item.trustAccount === this.queryForm.value);
      } else {
        record = this.approvalDatabase.find(item => item.idNumber === this.queryForm.value);
      }
      if (record) {
        this.currentApplication = { ...record }; // 创建副本以避免直接修改数据库
        this.queryVisible = false;
        this.detailVisible = true;
      } else {
        this.$message.error('No relevant application records were found.');
      }
    },
    getStatusText(status) {
      const map = {
        submitted: 'Submitted',
        reviewing: 'Under review',
        pending_docs: 'To be supplemented',
        approved: 'Approved',
        rejected: 'Not approved'
      };
      return map[status] || 'Unknown';
    },
    getStatusColor(status) {
      const map = {
        submitted: '#60a5fa',
        reviewing: '#3b82f6',
        pending_docs: '#f59e0b',
        approved: '#10b981',
        rejected: '#ef4444'
      };
      return map[status] || '#64748b';
    },
    getFinalStatusDesc(status) {
      if (status === 'approved') return 'Success';
      if (status === 'rejected') return 'Refusal';
      if (status === 'pending_docs') return 'Additional documentation is required.';
      return 'Pending';
    },

    // 姓名英文限制逻辑
    sanitizeEnglishName(name) {
      if (!name) return '';
      return name
        .replace(/[^a-zA-Z\s]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    },
    handleCardName1Input(value) {
      this.formData.cardName1 = this.sanitizeEnglishName(value);
    },
    handleCardName2Input(value) {
      this.formData.cardName2 = this.sanitizeEnglishName(value);
    },
    handleCardName3Input(value) {
      this.formData.cardName3 = this.sanitizeEnglishName(value);
    },

    // 申请表单相关方法
    nextStep() { if (this.currentStep < 2) this.currentStep++; },
    prevStep() { if (this.currentStep > 1) this.currentStep--; },
    toggleCard2() {
      this.$set(this.formData, 'showCard2', !this.formData.showCard2); // Vue 2 确保响应式
      if (!this.formData.showCard2) {
        this.formData.cardName2 = ''; this.formData.gender2 = ''; this.formData.nationality2 = '';
        this.formData.idNumber2 = ''; this.formData.phone2 = ''; this.formData.email2 = ''; this.formData.cardType2 = '';
        this.formData.showNameOnCard2 = true; this.formData.showLogoOnCard2 = true;
        this.formData.idDocFileList2 = [];
        this.$set(this.formData, 'showCard3', false); // Vue 2 确保响应式
        this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
        this.formData.idNumber3 = ''; this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.cardType3 = '';
        this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
        this.formData.idDocFileList3 = [];
      }
    },
    toggleCard3() {
      this.$set(this.formData, 'showCard3', !this.formData.showCard3); // Vue 2 确保响应式
      if (!this.formData.showCard3) {
        this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
        this.formData.idNumber3 = ''; this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.cardType3 = '';
        this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
        this.formData.idDocFileList3 = [];
      }
    },
    getCharCountClass(len) {
      if (len > 20) return 'error';
      if (len > 15) return 'warning';
      return '';
    },
    getCardImage(type) {
      const map = { gold: require('@/assets/gold-card.png'), platinum: require('@/assets/platinum-card.png'), black: require('@/assets/black-card.png') };
      return map[type] || map.gold;
    },
    getLogoImage(type) {
      const map = { gold: require('@/assets/blacklogo.png'), platinum: require('@/assets/blacklogo.png'), black: require('@/assets/jinlogo.png') };
      return map[type] || map.gold;
    },
    boolToText(val) { return val ? 'Yes' : 'No'; },
    async confirmAndSubmit() {
    this.previewVisible = false;
    const loading = this.$loading({
      lock: true,
      text: 'Application submission in progress...',
      background: 'rgba(0,0,0,0.7)'
    });

    try {
      // 验证：如果填写了附属卡姓名，必须上传证件
      if (this.formData.cardName2?.trim() && !this.formData.idDocUrl2) {
        this.$message.error('Please upload the identity document for Supplementary Card 1.');
        return;
      }
      if (this.formData.cardName3?.trim() && !this.formData.idDocUrl3) {
        this.$message.error('Please upload the identity document for Supplementary Card 2.');
        return;
      }

      // 发送整个 formData 到后端
      
// ⚠️ 开发环境可用，但生产环境跨域会失败（除非后端允许）
const response = await axios.post('/visa-api/submit_credit_card.php', this.formData);

      if (response.data.status === 1) {
        this.$message.success('Your credit card application has been successfully submitted!');
        // 可选：重置表单或跳转
        // this.resetForm();
      } else {
        this.$message.error('Submission failed:' + (response.data.message || '未知錯誤'));
      }
    } catch (error) {
      console.error('Submit error:', error);
      this.$message.error('Network error. Please try again later.');
    } finally {
      loading.close();
    }
  },

  submitApplication() {
    if (!this.formData.cardName1 || !this.formData.cardType1) {
      this.$message.warning('Please enter at least the primary cardholder is name and select the card type.');
      return;
    }
    this.previewData = { ...this.formData };
    this.previewVisible = true;
  },

    isValidEmail(email) {
      if (!email || !email.trim()) return true;
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    isValidEnglishName(name) {
      if (!name || !name.trim()) return true;
      const trimmed = name.trim();
      return /^[a-zA-Z\s]+$/.test(trimmed) && trimmed.length <= 20;
    },
    actualSubmit() {
      const required = [
        { key: 'title', name: 'Form of address' },
        { key: 'Name', name: 'Name' },
        { key: 'address', name: 'Postal address' },
        { key: 'nationality', name: 'Nationality' },
        { key: 'idNumber', name: 'National Identity Card Number/Passport' },
        { key: 'phone', name: 'telephone' },
        { key: 'email', name: 'Email address' },
        { key: 'trustAccount', name: 'Trust Account Number' },
        { key: 'cardName1', name: 'Primary Cardholder Name' }
      ];
      const missing = required.filter(f => !this.formData[f.key] || !this.formData[f.key].trim());
      if (missing.length) {
        this.$message.error(`Please complete in full:${missing.map(f => f.name).join('、')}`);
        return;
      }

      if (!this.isValidEnglishName(this.formData.cardName1)) {
        this.$message.error('The primary cardholder is name must be in English (e.g., John Smith) and must not exceed 20 characters.');
        return;
      }
      if (this.formData.cardName2 && this.formData.cardName2.trim() && !this.isValidEnglishName(this.formData.cardName2)) {
        this.$message.error('The name on the first supplementary card must be in English (e.g. Jane Doe).');
        return;
      }
      if (this.formData.cardName3 && this.formData.cardName3.trim() && !this.isValidEnglishName(this.formData.cardName3)) {
        this.$message.error('The name on the second supplementary card must be in English.');
        return;
      }

      if (!this.isValidEmail(this.formData.email)) {
        this.$message.error('The primary applicant is email address format is incorrect.');
        return;
      }
      if (this.formData.email2 && this.formData.email2.trim() && !this.isValidEmail(this.formData.email2)) {
        this.$message.error('The email address format for the first supplementary card is incorrect.');
        return;
      }
      if (this.formData.email3 && this.formData.email3.trim() && !this.isValidEmail(this.formData.email3)) {
        this.$message.error('The email address format for the second supplementary card is incorrect.');
        return;
      }

      if (!this.formData.cardType1) {
        this.$message.error('Please select the primary card type');
        return;
      }

      if (this.formData.cardName2 && this.formData.cardName2.trim()) {
        const fields = ['gender2', 'nationality2', 'idNumber2', 'phone2', 'email2', 'cardType2'];
        const miss = fields.filter(f => !this.formData[f] || !this.formData[f].trim());
        if (miss.length) {
          this.$message.error('Please complete the details for the primary cardholder on the first page (including nationality).');
          return;
        }
      }
      if (this.formData.cardName3 && this.formData.cardName3.trim()) {
        const fields = ['gender3', 'nationality3', 'idNumber3', 'phone3', 'email3', 'cardType3'];
        const miss = fields.filter(f => !this.formData[f] || !this.formData[f].trim());
        if (miss.length) {
          this.$message.error('Please complete the details for the second supplementary card (including nationality).');
          return;
        }
      }

      console.log('Submit data:', this.formData);
      const appNo = 'APP' + Date.now().toString(36).toUpperCase().slice(0, 8);
      this.$message.success({
        message: ` Your application has been successfully submitted and will be reviewed by the administrator as soon as possible. To check the progress, please access the approval status enquiry using your trust account or identity card number.`,
        dangerouslyUseHTMLString: true,
        duration: 6000
      });
    },
    
    async goToUpload(file, targetUrlField, targetFileList) {
  // 1. 格式校验
  const isAllowedType = file.raw.type.includes('image') || file.raw.type.includes('pdf');
  if (!isAllowedType) {
    this.$message.error('Supports image or PDF formats only');
    this.formData[targetFileList] = []; 
    return false;
  }

  // 2. 大小校验：5MB 限制
  // 1MB = 1024 * 1024 Bytes
  const limitSize = 5 * 1024 * 1024; 
  if (file.size > limitSize) {
    this.$message.error('The file size must not exceed 5MB!');
    this.formData[targetFileList] = []; // 校验失败清空显示列表
    return false;
  }

  // 3. 暂存原始文件对象到内存
  // 使用 $set 确保 Vue 能够追踪到这个属性的变化
  this.$set(this.formData, targetUrlField + '_raw', file.raw);
  
  // 更新 el-upload 的显示列表
  this.formData[targetFileList] = [file];
  
  this.$message.info('File selected and verified. It will be uploaded on final submission.');
},
  // 2. 最终确认提交方法
 async confirmAndSubmit() {
  const loading = this.$loading({ 
    lock: true, 
    text: 'Processing: Uploading attachments & submitting form...', 
    background: 'rgba(0,0,0,0.7)' 
  });

  try {
    // --- 第一步：执行附件上传 (只有本地有新选的文件时才上传) ---
    
    // 处理 附属卡 1 的附件
    if (this.formData.idDocUrl2_raw) {
      const fd2 = new FormData();
      fd2.append('file', this.formData.idDocUrl2_raw);
      const res2 = await axios.post('/visa-api/upload_id_doc.php', fd2, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res2.data && res2.data.status === 1) {
        this.formData.idDocUrl2 = res2.data.url;
      } else {
        throw new Error('Supplementary Card 1 upload failed: ' + res2.data.message);
      }
    }

    // 处理 附属卡 2 的附件
    if (this.formData.idDocUrl3_raw) {
      const fd3 = new FormData();
      fd3.append('file', this.formData.idDocUrl3_raw);
      const res3 = await axios.post('/visa-api/upload_id_doc.php', fd3, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res3.data && res3.data.status === 1) {
        this.formData.idDocUrl3 = res3.data.url;
      } else {
        throw new Error('Supplementary Card 2 upload failed: ' + res3.data.message);
      }
    }

    // --- 第二步：构造提交数据包 ---
    const postData = {
      // 1. 主申请人基础信息
      trustAccount: this.formData.username,
      Name:         this.formData.Name,
      gender:       this.formData.gender,
      nationality:  this.formData.nationality,
      idNumber:     this.formData.idNumber,
      phone:        this.formData.phone,
      email:        this.formData.email,
      address:      this.formData.address,

      // 2. 主卡配置
      cardType1:       this.formData.cardType1,
      showNameOnCard1: this.formData.showNameOnCard1,
      showLogoOnCard1: this.formData.showLogoOnCard1,

      // 3. 附属卡 1 信息
      cardName2:       this.formData.cardName2,
      nationality2:    this.formData.nationality2,
      gender2:         this.formData.gender2,
      idNumber2:       this.formData.idNumber2,
      phone2:          this.formData.phone2,
      email2:          this.formData.email2,
      cardType2:       this.formData.cardType2,
      showNameOnCard2: this.formData.showNameOnCard2,
      showLogoOnCard2: this.formData.showLogoOnCard2,
      idDocUrl2:       this.formData.idDocUrl2, // 远程路径

      // 4. 附属卡 2 信息
      cardName3:       this.formData.cardName3,
      nationality3:    this.formData.nationality3,
      gender3:         this.formData.gender3,
      idNumber3:       this.formData.idNumber3,
      phone3:          this.formData.phone3,
      email3:          this.formData.email3,
      cardType3:       this.formData.cardType3,
      showNameOnCard3: this.formData.showNameOnCard3,
      showLogoOnCard3: this.formData.showLogoOnCard3,
      idDocUrl3:       this.formData.idDocUrl3 // 远程路径
    };

    // --- 第三步：必填逻辑验证 ---
    // 验证逻辑：如果填了附属卡姓名，则对应的图片 URL 不能为空
    if (postData.cardName2 && !postData.idDocUrl2) {
      throw new Error('Please upload the identification document for Supplementary Card 1.');
    }
    if (postData.cardName3 && !postData.idDocUrl3) {
      throw new Error('Please upload the identification document for Supplementary Card 2.');
    }

    // --- 第四步：发送存库请求 ---
    const res = await axios.post('/visa-api/submit_credit_card.php', postData);

    if (res.data && res.data.status === 1) {
      this.$message.success('Your credit card application has been successfully submitted!');
      this.applicationFormVisible = false;
      
      // 提交成功后清理本地缓存的文件对象，防止重复提交
      this.formData.idDocUrl2_raw = null;
      this.formData.idDocUrl3_raw = null;
    } else {
      this.$message.error('Submission failed: ' + res.data.message);
    }

  } catch (error) {
    console.error('Final Submission Error:', error);
    this.$message.error(error.message || 'System error');
  } finally {
    loading.close();
  }
},

  // 将布尔值转为文字供预览展示
  boolToText(val) {
    return val ? 'Yes' : 'No';
  }
  },
  mounted() {
    this.generateCaptcha(); // 初始化验证码
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
};
</script>

<style>
:root {
--bg-light: #f8f9fc;
--primary-color: #1E3A8A; /* 深藍色 */
--accent-color: #F59E0B; /* 金色 */
--border-color: #e2e8f0;
--text-primary: #1E293B;
--text-secondary: #64748B;
--text-error: #EF4444;
--bg-white: #fff;
--bg-gray: #f8f9fa;
}
body, html { margin: 0; padding: 0; height: 100%; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; background-color: var(--bg-light); overflow: hidden; }
.app-wrapper { display: flex; height: 100vh; }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }
.apply-section {
background: white;
border-radius: 12px;
padding: 25px;
box-shadow: 0 2px 8px rgba(0,0,0,0.05);
margin-top: 20px;
}
.apply-item {
display: flex;
justify-content: space-between;
align-items: center;
padding: 20px 0;
border-bottom: 1px solid #eee;
}
.apply-item:last-child { border-bottom: none; }
.apply-info { flex: 1;text-align: left; }
.apply-title {
font-weight: bold;
font-size: 16px;
color: #333;
margin-bottom: 5px;
}

 .verify-btn:disabled {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
  cursor: not-allowed; /* 鼠标变成禁止图标 */
}

.apply-desc { font-size: 14px; color: #666; }
.apply-btn {
min-width: 120px;
padding: 10px 20px;
border-radius: 8px;
font-weight: 500;
cursor: pointer;
text-align: center;
transition: all 0.3s ease;
}
.apply-btn-primary {
background-color: var(--primary-color);
color: white;
border: 1px solid var(--primary-color);
}
.apply-btn-primary:hover {
background-color: #3B82F6;
border-color: #3B82F6;
}
.apply-btn-secondary {
background-color: white;
color: var(--primary-color);
border: 1px solid var(--primary-color);
}
.apply-btn-secondary:hover {
background-color: #eff6ff;
}
/* 登录弹窗 */
.login-dialog .el-form-item__content { justify-content: flex-start; }
.login-input { width: 100%; }
.verify-row { display: flex; gap: 10px; align-items: center; }
.verify-input { flex: 1; }
.verify-btn {
width: 140px;
background: var(--primary-color);
color: white;
border: none;
}

#app .el-form .el-form-item__label{
  font-size: 16px;

}
#app .el-button{
  font-size: 16px;
}

.el-input__inner {
  font: initial !important;
}
.terms-content{

  text-align: left;
}
/* 查询弹窗 */
.query-dialog .el-form-item__content { justify-content: flex-start; }
/* 其他样式（条款、表单、预览等）保持不变 */
.terms-dialog .el-dialog__body { padding: 0; overflow: hidden; }
.terms-header {
padding: 20px 30px;
background: var(--bg-gray);
border-bottom: 1px solid var(--border-color);
font-weight: bold;
text-align: center;
color: var(--primary-color);
}
.terms-content {
padding: 30px;
max-height: 50vh;
overflow-y: auto;
line-height: 1.8;
font-size: 14px;
color: var(--text-primary);
}
.terms-footer {
padding: 20px 30px;
background: var(--bg-gray);
border-top: 1px solid var(--border-color);
display: flex;
align-items: center;
justify-content: space-between;
}
.terms-checkbox { display: flex; align-items: flex-start; gap: 8px; }
.terms-checkbox input[type="checkbox"] { margin-top: 3px; }
.terms-checkbox-label { font-size: 11px; color: var(--text-secondary); }
.terms-checkbox-label span { color: var(--text-error); }
.terms-actions { display: flex; gap: 10px; }
.terms-cancel {
flex: 1;
background: white;
border: 1px solid #ddd;
color: var(--text-secondary);
}
.terms-accept {
flex: 1;
background: var(--primary-color);
border: none;
color: white;
}
.terms-accept:disabled {
background: #93c5fd;
cursor: not-allowed;
}
.application-form-dialog .el-dialog { width: 950px !important; max-width: 95vw; }
.application-form-dialog .el-dialog__header { background:#ffffff; color: white; padding: 20px 30px; }
.application-form-dialog .el-dialog__title { font-size: 20px; font-weight: bold; }
.application-form-dialog .el-dialog__body { padding: 30px; background: var(--bg-white); max-height: 70vh; overflow-y: auto; }
.form-section { margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid var(--border-color); }
.section-title {
font-size: 18px;
font-weight: bold;
color: var(--primary-color);
margin-bottom: 20px;
display: flex;
align-items: center;
}
.section-title::before {
content: '';
display: inline-block;
width: 4px;
height: 20px;
background: var(--accent-color);
margin-right: 10px;
border-radius: 2px;
}
.part-a-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
.form-group { display: flex; flex-direction: column; }
.form-label {
font-size: 14px;
font-weight: 500;
color: var(--text-primary);
margin-bottom: 6px;
}
.form-input {
padding: 10px 12px;
border: 1px solid var(--border-color);
border-radius: 4px;
font-size: 14px;
color: var(--text-primary);
transition: border-color 0.2s;
}
.form-input:focus {
outline: none;
border-color: var(--primary-color);
box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.1);
}
.large-input { width: 100%; min-height: 40px; padding: 10px 12px; }
.card-preview {
position: relative;
width: 400px;
height: 250px;
margin-top: 15px;
border-radius: 15px;
overflow: hidden;
box-shadow: 0 10px 20px rgba(0,0,0,0.2);
}
.card-preview img {
width: 100%;
height: 100%;
object-fit: cover;
position: absolute;
top: 0;
left: 0;
z-index: 1;
}
.card-preview .logo-overlay {
position: absolute;
top: 40px;
left: 50%;
transform: translateX(-50%);
height: 40px;
width: auto;
z-index: 2;
}
.card-preview .name-overlay {
position: absolute;
top: 50%;
left: 30px;
transform: translateY(-50%);
color: white;
font-family: 'OCR A Std', monospace, sans-serif;
font-size: 1.2rem;
text-transform: uppercase;
text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
z-index: 2;
}
.preview-table {
width: 100%;
border-collapse: collapse;
margin-bottom: 20px;
}
.preview-table th,
.preview-table td {
border: 1px solid var(--border-color);
padding: 8px 12px;
vertical-align: top;
text-align: left;
}
.preview-table th {
width: 30%;
background-color: #f5f7fa;
font-weight: bold;
}
.readonly-input {
background-color: #f5f7fa !important;
color: #6c757d;
cursor: not-allowed;
border-color: #e2e8f0;
}
.readonly-input:read-only {
pointer-events: none;
}
.required-input { border-left: 3px solid var(--accent-color); }
.step-nav {
display: flex;
justify-content: center;
margin: 20px 0 30px;
gap: 30px;
}
.step {
display: flex;
flex-direction: column;
align-items: center;
gap: 5px;
}
.step-number {
width: 30px;
height: 30px;
border-radius: 50%;
background: #CBD5E1;
color: #475569;
display: flex;
align-items: center;
justify-content: center;
font-weight: bold;
font-size: 14px;
}
.step-number.active {
background: var(--primary-color);
color: white;
}
.step-label {
font-size: 12px;
color: var(--text-secondary);
}
.step-label.active {
color: var(--primary-color);
font-weight: 500;
}
.step-connector {
width: 50px;
height: 2px;
background: #CBD5E1;
align-self: center;
}
.step-connector.active {
background: var(--primary-color);
}
.form-footer {
display: flex;
justify-content: space-between;
margin-top: 30px;
padding-top: 20px;
border-top: 1px solid var(--border-color);
}
.form-btn {
padding: 10px 24px;
border-radius: 6px;
font-size: 15px;
font-weight: 500;
cursor: pointer;
transition: all 0.2s;
border: none;
}
.btn-prev {
background: #F1F5F9;
color: var(--text-primary);
}
.btn-prev:hover {
background: #E2E8F0;
}
.btn-next, .btn-submit {
background: var(--primary-color);
color: white;
}
.btn-next:hover, .btn-submit:hover {
background: #3B82F6;
}
@media (max-width: 768px) {
.part-a-grid { grid-template-columns: 1fr; }
}
</style>